import imgResearchAreasAgentNew from '../assets/images/research-areas-agent_new.png';
import imgResearchAreasHealthNew from '../assets/images/research-areas-health_new.png';
import imgResearchAreasBiologyNew from '../assets/images/research-areas-biology_new.png';
import imgMedicalBio from '../img/生物.png';
import imgResearchAreasMathNew from '../img/数学智能1.png';
import imgResearchAreasEnergy from '../img/image-energy.png';
import imgPowerForecast from '../assets/images/power-forecast.png';
import imgPowerStorage from '../assets/images/power-storage.png';
import imgPowerLoad from '../assets/images/power-load.png';
import imgPowerRetail from '../assets/images/power-retail.jpg';
import imgResearchAreasLlm from '../assets/images/research-areas-llm.png';
import imgFlemingR1 from '../assets/images/Fleming-R1.png';
import imgAIAgent from '../assets/images/AI-Agent.png';
import imgHOTE from '../assets/images/HOTE.png';
import imgLifeUBio from '../assets/images/life-UBio.png';
import imgMathAnderson from '../assets/images/Math-Anderson.png';
import imgMathAutoformalizer from '../assets/images/Math-Autoformalizer.png';
import imgMathRetrieve from '../assets/images/Math-Retrieve.png';
import { t, isOverseas } from '../utils/i18n';

const joinUsUrl = 'https://app.mokahr.com/social-recruitment/mountainxplorerrecruit/164193?locale=zh-CN#/';

// 统一页面配置：数据节点供路由页面消费
// name     — 导航及分页点共用名称
// children — 二级菜单项（type: "anchor" 含 data 为研究方向, type: "page" 跳转新页面）
const PAGES_CONFIG = [
    {
        id: "iquest",
        index: 0,
        name: "IQuest",
    },
    {
        id: "explore",
        index: 1,
        name: t("探索", "Explore"),
        data: [
            {
                id: "llm",
                title: t("大模型", "Large Models"),
                img: imgResearchAreasAgentNew,
                desc: t(
                    "打造高性能、易部署、强推理的大模型体系，解决真实场景中的复杂任务执行需求",
                    "High-performance, easy-to-deploy, strong-reasoning LIM system, built to tackle complex task execution in real-world scenarios."
                ),
            },
            {
                id: "medical-ai",
                title: t("医疗智能", "Medical AI"),
                img: imgResearchAreasHealthNew,
                desc: t(
                    "以推理、视觉理解与循证应用为核心，构建覆盖医学语言、多模态与助手产品的系统化能力矩阵",
                    "Centered on reasoning, visual understanding, and evidence-based practice, we build systematic capability that spans medical language, multimodal, and AI assistant products."
                ),
            },
            {
                id: "life-science",
                title: t("生命科学", "Life Sciences"),
                img: imgResearchAreasBiologyNew,
                desc: t(
                    "坚持End-First思考，打造自主智能生物大模型，从分子设计到实验验证全程自主闭环，用顶尖科学计算与全站技术体系，定义生命科学智能研发新高度",
                    "Guided by End-First thinking, we build an autonomous intelligent bio-foundation model, forming a closed loop from molecular design to experimental validation. Leveraging cutting-edge scientific computing and a full-stack technology system, we redefine the intelligent R&D in life sciences."
                ),
            },
            {
                id: "math",
                title: t("数学智能", "Mathematical AI"),
                img: imgResearchAreasMathNew,
                desc: t(
                    "以推理策略、形式化验证、引理检索为锚点，构建从自然语言到形式化数学的全链条AI能力体系。",
                    "Anchored in reasoning strategies, formal verification and lemma retrieval, we build a full-chain AI capability system spanning natural language to formal mathematics."
                ),
            },
            {
                id: "power",
                title: t("数智电力", "Power Intelligence"),
                img: imgResearchAreasEnergy,
                desc: t(
                    "聚焦AI在新型电力系统中的核心应用，构建从数据感知、时序预测、市场建模到交易决策和风险复盘的全链路技术体系。",
                    "Focusing on the core applications of AI in new-type power systems, we establish a full-link technical framework covering data perception, time-series forecasting, market modeling, trading decision-making and risk review."
                ),
            },
        ],
        children: [
            {
                id: "llm",
                name: t("大模型", "Large Models"),
                type: "anchor",
                anchorId: "llm",
                data: {
                    leftInfo: {
                        img: imgResearchAreasLlm,
                        title: "IQuest-Q1",
                        desc: t(
                            "320B-A15B，面向代码与复杂任务执行，覆盖软件工程、长上下文、工具调用与多步推理",
                            <>320B total parameters · 15B activated<br/>Built for coding and complex agentic tasks, with capabilities spanning software engineering, long-context understanding, tool use, and multi-step reasoning.</>
                        ),
                        href: "https://iquestlab.github.io",
                    },
                    rightList: [
                        {
                            iconName: 'layers',
                            title: t('稀疏MoE架构', 'Sparse MoE Architecture'),
                            desc: t(
                                '320B总参数、15B激活参数，以较低激活规模支撑代码与复杂智能体任务',
                                '320B total parameters, with 15B activated per token, supporting coding and complex agentic tasks with a smaller active footprint.'
                            )
                        },
                        {
                            iconName: 'code',
                            title: t('多阶段智能体训练', 'Multi-Stage Agent Training'),
                            desc: t(
                                '从预训练、中期训练到后训练，逐步增强代码、推理与长程任务执行能力',
                                'Pre-training, mid\u2011training, and post\u2011training progressively build the model’s coding, reasoning, and long\u2011horizon task execution capabilities. '
                            )
                        },
                        {
                            iconName: 'merge',
                            title: t('多环境Agent学习', 'Agent Learning Across Environments'),
                            desc: t(
                                '在代码仓库、CLI、工具与工作空间等环境中训练，强化连续执行和错误恢复',
                                'Trained across code repositories, CLI environments, tools, and workspaces to strengthen sustained task execution and recovery from errors.'
                            )
                        },
                        {
                            iconName: 'repeat',
                            title: t('多能力统一融合', 'Capabilities Consolidated in One Model'),
                            desc: t(
                                '通过强化学习、MOPD与模型融合，将不同任务方向的能力整合进统一模型',
                                'Reinforcement learning, multi\u2011teacher on\u2011policy distillation (MOPD), and model merging bring capabilities from different task domains into a single model.'
                            )
                        },
                        {
                            iconName: 'rocket',
                            title: t('模型参与研发闭环', 'Model\u2011Assisted R&D Loop'),
                            desc: t(
                                '模型参与诊断、实验与迭代，训练资产和研发流程可持续复用于后续版本',
                                'The model contributes to diagnosis, experimentation, and iteration under human supervision. Validated training assets and research workflows can be reused in future development cycles.'
                            )
                        }
                    ]
                },
            },
            {
                id: "medical-ai",
                name: t("医疗智能", "Medical AI"),
                type: "anchor",
                anchorId: "medical-ai",
                data: [
                    {
                        img: imgFlemingR1,
                        group: 'matrix',
                        title: t("Fleming-R1 医疗推理大模型", "Fleming\u2011R1 Medical Reasoning Model"),
                        desc: t(
                            "基于强化学习打造全透明临床决策引擎，首创RODS数据合成与双阶段RLVR技术，严控幻觉，输出完整可审计的临床思维路径。",
                            "A fully transparent clinical decision engine powered by reinforcement learning. Pioneering RODS data synthesis and dual\u2011stage RLVR technology, tightly control hallucinations, delivering auditable clinical reasoning pathways."
                        )
                    },
                    {
                        img: imgMedicalBio,
                        group: 'matrix',
                        title: t("Fleming-VL 多模态医学大模型", "Fleming\u2011VL Multimodal Medical Model"),
                        desc: t(
                            "首创［视觉-投影-语言］端到端架构，支持2D/3D/动态视频全模态处理，结合CoT与GRPO强化学习，实现可解释的医学视觉推理。",
                            "Pioneering end\u2011to\u2011end \u300Cvision\u2011to\u2011language\u300D architecture for 2D/3D video data. With CoT and GRPO reinforcement learning, it achieves explainable medical visual reasoning."
                        )
                    },
                    {
                        img: imgAIAgent,
                        group: 'agent',
                        title: t("明医问问医疗 AI Agent", "Medical AI Agent"),
                        desc: t(
                            "集成百万级知识库，自动检索权威指南，实现知识增强、 有证可循的医学问答，同步提供参考文献，支持多模态联合诊疗",
                            "Integrated with million\u2011scale knowledge base and automatic retrieval of authoritative guidelines, it delivers knowledge\u2011augmented, evidence\u2011based medical Q&A, complete with cited references, and support for multimodal collaborative diagnosis."
                        )
                    },
                    {
                        img: imgHOTE,
                        group: 'framework',
                        title: t("HOTE智能体进化框架", "HOTE Agent Evolution Framework"),
                        desc: t(
                            "首创Proposer-Solver-Judge三元协同机制，实现专家级复杂病案分析。Tool-use与No-tool双模态混合强化学习，大幅降低训练成本。",
                            "Pioneering Proposer\u2011Solver\u2011Judge tripartite collaboration mechanism, deliver expert\u2011level analysis of complex medical cases. Dual\u2011mode (Tool\u2011use and No\u2011tool) hybrid reinforcement learning significantly reduces training costs."
                        )
                    }
                ],
            },
            {
                id: "life-science",
                name: t("生命科学", "Life Sciences"),
                type: "anchor",
                anchorId: "life-science",
                data: [
                    {
                        img: imgLifeUBio,
                        title: isOverseas
                            ? 'UBio\u2011MolFM Foundational Model Framework for Biomacromolecules'
                            : 'UBio-MolFM生物大分子基础模型框架',
                        desc: isOverseas
                            ? 'A high-precision molecular simulation foundation model framework for biomacromolecular. Breaking the scale-accuracy trade-off in biomacromolecular simulation \u2014 higher precision, faster inference.'
                            : '面向生物大分子体系的高精度分子模拟基础模型框架，突破尺度-精度矛盾，实现更高精度与更快推理',
                        href: isOverseas
                            ? 'https://github.com/IQuestLab/UBio-MolFM' // 'https://iquestlab.github.io/UBio-ARCK/'
                            : 'https://github.com/IQuestLab/UBio-MolFM', // 'https://iquestlab.github.io/UBio-ARCK/zh/',
                        back: [
                            {
                                iconName: 'database',
                                title: t('UBio-Mol26/Protein26', 'UBio\u2011Mol26 / Protein26'),
                                desc: t(
                                    '高质量DFT数据集，覆盖蛋白、DNA/RNA、脂质膜及显式溶剂体系',
                                    'High\u2011quality DFT datasets covering proteins, DNA/RNA, lipid membranes, and explicit solvent systems'
                                )
                            },
                            {
                                iconName: 'cpu',
                                title: t('E2Former-V2等变架构', 'E2Former\u2011V2 Equivariant Architecture'),
                                desc: t(
                                    'EAAS稀疏化+LSR长短程建模，硬件友好、低推理开销',
                                    'EAAS sparsification + LSR long-short\u2011range modeling, hardware-friendly, low inference overhead'
                                )
                            },
                            {
                                iconName: 'layers',
                                title: t('三阶段课程学习', 'Three\u2011Stage Curriculum Learning'),
                                desc: t(
                                    '稳定融合多理论层级数据，保障能量-力一致性',
                                    'Stably integrates multi\u2011level theoretical data, ensures energy\u2011force consistency'
                                )
                            },
                            {
                                iconName: 'shield',
                                title: t('1300-1500原子SOTA精度', 'SOTA Accuracy for 1,300\u20131,500 Atoms'),
                                desc: t(
                                    '生物大分子外推基准领先，可靠复现溶剂、构象与金属配位关键特性',
                                    'Leading benchmarks in biomacromolecule extrapolation; reliably reproduces key properties: solvation, conformation, and metal coordination'
                                )
                            },
                            {
                                iconName: 'zap',
                                title: t('1k-50k原子4x吞吐提升', '4\u00d7 Throughput Boost for 1k\u201350k Atoms'),
                                desc: t(
                                    '单卡高效推理，性能大幅优于主流模型，满足工程化分子模拟需求',
                                    'Efficient single\u2011GPU inference, vastly outperforms mainstream models, ready for engineering\u2011scale molecular simulation'
                                )
                            }
                        ]
                    },
                ],
            },
            {
                id: "math",
                name: t("数学智能", "Mathematical AI"),
                type: "anchor",
                anchorId: "math",
                data: [
                    {
                        img: imgMathAnderson,
                        title: t("攻克 Anderson 猜想", "Conquering Anderson's Conjecture"),
                        desc: t(
                            "与北京大学国际数学研究中心合作，结合研究实践的推理策略和证明方法，从海量形式化定理及自然语言陈述中精准检索，通过自主寻径机制，成功攻克Anderson猜想，并在Lean4中完成了约19,000行的形式化验证。",
                            "In collaboration with the Center for Machine Learning Research Peking University, using research\u2011driven reasoning strategies and proof methods, we accurately retrieve from massive repositories of formal theorems and natural\u2011language statements. Through an autonomous path\u2011finding mechanism, we successfully conquered Anderson's Conjecture and completed approximately 19,000 lines of formal verification in Lean4."
                        )
                    },
                    {
                        img: imgMathAutoformalizer,
                        title: "Autoformalizer",
                        desc: t(
                            "自然语言到数学语言的无损互译，实现复杂数理逻辑精准转译、知识结构化重构，赋能全场景数学智能化分析与自动化业务流转。",
                            "Lossless translation between natural language and mathematical language, enabling precise transformation of complex mathematical logic and knowledge structuring, empowering full\u2011scenario intelligent analysis and automated workflows."
                        )
                    },
                    {
                        img: imgMathRetrieve,
                        title: t("数学引理检索", "Mathematical Lemma Retrieval"),
                        desc: t(
                            "与北京大学国际数学中心合作，提供达到SOTA级别的自然语言及Lean语言引理检索能力，有效支持复杂数学证明中的引理查找需求。",
                            "In collaboration with the Center for Machine Learning Research Peking University, we deliver SOTA-level lemma retrieval capabilities for both natural language and Lean, effectively support lemma lookup in complex mathematical proofs."
                        )
                    }
                ],
            },
            {
                id: "power",
                name: t("数智电力", "Power Intelligence"),
                type: "anchor",
                anchorId: "power",
                data: [
                    {
                        img: imgPowerForecast,
                        title: t("风光电站功率预测与交易", "Power Forecasting & Trading for Renewable Plants"),
                        slogan: t(
                            "让波动性新能源具备更强可预测性与可管理性",
                            "Making variable renewables more predictable and manageable"
                        ),
                        desc: t(
                            "融合卫星、雷达、数值天气预报与场站实测数据，构建覆盖超短期至中长期的功率预测体系，支撑新能源场站运行、偏差管理、申报协同与自动交易。",
                            "Integrating satellite, radar, NWP, and on-site data, the system delivers ultra-short- to long-term power forecasts for renewable plant operations, imbalance management, schedule submission, and automated trading."
                        ),
                        tags: [t('自研气象大模型 AI-NWP', 'AI-NWP'), '3D Swin V2 × Graph Neural Operator', t('功率预测模型', 'Power Forecasting'), t('气象误差传导', 'Weather-to-Power Error Propagation')],
                    },
                    {
                        img: imgPowerStorage,
                        title: t("储能系统智慧运营", "Smart Energy Storage Operations"),
                        slogan: t(
                            "让储能在不同电价、负荷与运行场景中释放更高资产价值",
                            "Unlocking greater asset value from energy storage"
                        ),
                        desc: t(
                            "围绕储能系统在用户侧、电网侧、电源侧的多重价值，结合电网调节需求、电价信号、负荷曲线、设备状态与运行约束，生成更优的市场选择策略、充放电策略，支持现货价差捕捉、需量管理与分时用电优化。",
                            "Combining grid regulation needs, price signals, load profiles, asset status, and operating constraints, the system optimizes market participation and charge–discharge strategies across customer-side, grid-side, and generation-side scenarios."
                        ),
                        tags: [t('收益结构优化', 'Revenue Stack Optimization'), t('日内能量优化', 'Intraday Energy Optimization'), t('充放电策略生成', 'Charge–Discharge Strategy'), t('负荷尖峰识别', 'Peak Load Detection'), t('分时用电曲线优化', 'TOU Optimization')],
                    },
                    {
                        img: imgPowerLoad,
                        title: t("用户侧柔性负荷运行管理", "Customer-Side Flexible Load Management"),
                        slogan: t(
                            "让用户侧负荷从被动消耗转向可验证、可调节、可协同的能源资源",
                            "Turning flexible loads into verifiable and dispatchable energy resources"
                        ),
                        desc: t(
                            "面向用户侧可调节负荷资源，基于高频用能数据、天气工况特征与 A/B Test 确权机制，建立动态用能基线，并通过 AI 调节策略支持能效优化、削峰填谷与需求响应。",
                            "Using high-frequency consumption data, weather and operating-condition features, and A/B test-based attribution, the system builds dynamic baselines and enables AI-driven load control for efficiency optimization, peak shaving, and demand response."
                        ),
                        tags: [t('15min 高频数据采集', '15-Minute Data Collection'), t('动态基线建模', 'Dynamic Baseline Modeling'), t('A/B Test 确权', 'A/B Test Attribution'), t('AI 负荷调节', 'AI Load Control')],
                    },
                    {
                        img: imgPowerRetail,
                        title: t("用户侧电力零售与交易", "Customer-Side Electricity Retail & Trading"),
                        slogan: t(
                            "推动用户侧电力服务走向更精细、更智能的运营管理",
                            "Enabling more intelligent customer-side electricity services"
                        ),
                        desc: t(
                            "基于用户侧用电曲线、分时电价与零售服务运营需求，构建用能分析、费用优化与服务支撑能力，帮助售电公司和综合能源服务商提升精细化运营水平。",
                            "Based on load profiles, TOU tariffs, and retail service needs, the system supports consumption analysis, cost optimization, and refined operations for electricity retailers and integrated energy service providers."
                        ),
                        tags: [t('用电曲线分析', 'Load Profile Analysis'), t('分时电价优化', 'TOU Tariff Optimization'), t('零售服务运营', 'Retail Operations'), t('费用结构评估', 'Cost Structure Assessment')],
                    }
                ],
            },
        ],
    },
    {
        id: "updates",
        index: 2,
        name: t("动态", "Updates"),
        children: [
            {
                id: "blog",
                name: t("博客", "Blog"),
                type: "anchor",
                anchorId: "blog",
                data: [
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'IQuest-Coder-v1',
                        date: '2026-01-01',
                        href: 'https://iquestlab.github.io/'
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: t('FATE评测集', 'FATE Benchmark'),
                        date: '2025-08-26',
                        href: 'https://frenzymath.com/blog/fate/',
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: 'Archon',
                        date: '2026-03-13',
                        href: 'https://frenzymath.com/blog/archon-firstproof/',
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: 'Anderson-Conjecture',
                        date: '2026-04-04',
                        href: 'https://frenzymath.com/blog/conjecture/',
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: 'Matlas',
                        date: '2026-04-18',
                        href: 'https://frenzymath.com/blog/matlas/',
                    },
                ],
            },
            {
                id: "news",
                name: t("新闻", "News"),
                type: "anchor",
                anchorId: "news",
                data: [
                    {
                        tag: t("大模型", "Large Models"),
                        title: '至知发布IQuestRT，让IQuest-Q1推理吞吐提升至近3倍',
                        date: '2026-11-05',
                        href: 'https://mp.weixin.qq.com/s/9-mjHX6mTdl6AiB-DzgANQ',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'IQuest-Q1技术报告公开：30项评测与模型的完整训练路径',
                        date: '2026-10-26',
                        href: 'https://mp.weixin.qq.com/s/f-4dTHwDbYPksHHEs9atGw',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '至知创新研究院发布并开源IQuest-Q1',
                        date: '2026-09-30',
                        href: 'https://mp.weixin.qq.com/s/J57NgGoJz--Df_qL50_2JA',
                    },
                    {
                        tag: t("生命科学", "Life Sciences"),
                        title: '论文解读｜单卡跑18万原子！UBio-MolFM v1.5，分子模拟的"规模焦虑"该终结了',
                        date: '2026-09-18',
                        href: 'https://mp.weixin.qq.com/s/hj3W6HLlb2hBeZIc-9RZ-Q',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '论文解读｜至知8篇论文被国际顶会EMNLP 2026录用，前沿成果持续输出',
                        date: '2026-09-18',
                        href: 'https://mp.weixin.qq.com/s/FO5utxKKonf4tQ6OWG-F3A',
                    },
                    {
                        tag: t("医疗智能", "Medical AI"),
                        title: '论文解读｜AI像医生一样"边看边想"，UniReason-Med实现2D/3D医学影像统一视觉推理',
                        date: '2026-09-18',
                        href: 'https://mp.weixin.qq.com/s/xsts37jUuqD-vn_qVHudnQ',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '论文解读｜让模型范数稳定下来，Hyperball类优化器会是"免费午餐"吗?',
                        date: '2026-09-01',
                        href: 'https://mp.weixin.qq.com/s/UumHEOU6yZaj4yRYspI7GQ',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '论文解读｜理解大模型，无需再训练一个替代网络：SWD直接拆解权重，数据成本不到1%',
                        date: '2026-09-01',
                        href: 'https://mp.weixin.qq.com/s/tZuJl--3MecmIP893FLsUw',
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: '研发笔记｜长程推理鸿沟如何跨越？自研Prover给出答案',
                        date: '2026-09-01',
                        href: 'https://mp.weixin.qq.com/s/Mpvj3Y6cvdDKkKyFkKkdOQ',
                    },
                    {
                        id: 'math-prover-multi-agent',
                        tag: t("数学智能", "Mathematics"),
                        title: '研发笔记｜数学Prover多智能体协作证明框架',
                        date: '2026-07-28',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '上海财经大学-至知创新研究院大模型算法与机理研究联合实验室揭牌成立',
                        date: '2026-06-23',
                        href: 'https://mp.weixin.qq.com/s/FtIpIZBnVTSRZYs1MPU7yw',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '上海交通大学与至知创新研究院携手共建多模态大模型联合实验室打造全国产自主可控AI产学研新高地',
                        date: '2026-06-15',
                        href: 'https://news.sjtu.edu.cn/jdyw/20260615/223771.html',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '把真实GitHub仓库转化为可执行终端轨迹！TerminalTraj入选ICML 2026',
                        date: '2026-06-15',
                        href: 'https://mp.weixin.qq.com/s/oxwMCZy6ZaXeR6lpUa6OQA',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '打破Agent训练瓶颈！人大&至知研究院开源Claw Agent数据+训练+评测全链条',
                        date: '2026-05-30',
                        href: 'https://mp.weixin.qq.com/s/zdU2ovW0LF0TMIY0M6ZoBw',
                    },
                    {
                        tag: t("数学智能", "Mathematics"),
                        title: 'AI解决数学猜想的新突破！至知创新研究院联合北大团队的探索',
                        date: '2026-04-09',
                        href: 'https://mp.weixin.qq.com/s/ihT5I_rS5eMgS4aZVHBm-Q',
                    },
                    {
                        tag: t("医疗智能", "Medical AI"),
                        title: '北京大学第一医院与九坤至知创新研究院成立AI医疗联合实验室',
                        date: '2026-04-03',
                        href: 'https://mp.weixin.qq.com/s/7S2Ke5rH8wwMjLDkHFNM0w',
                    },
                    {
                        tag: t("生命科学", "Life Sciences"),
                        title: '至知发布UBio-MolFM大模型：面向生物体系大规模分子场景，实现SOTA级精度和吞吐',
                        date: '2026-03-04',
                        href: 'https://mp.weixin.qq.com/s/jAzX6euQA3hc6QRfVI2qFA',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '至知创新研究院更新 IQuest-Coder-V1 版本',
                        date: '2026-03-02',
                        href: 'https://mp.weixin.qq.com/s/UgmUkQk4bnTmcHsdUxXuyA',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: '挑战强化学习后训练霸权！全新无监督方法仅需1条数据+10步优化',
                        date: '2025-06-01',
                        href: 'https://mp.weixin.qq.com/s/3TE_mFq-pjj2Ebv3W1XNKw',
                    },
                ],
            },
            {
                id: "publications",
                name: t("出版物", "Publications"),
                type: "anchor",
                anchorId: "publications",
                data: [
                    {
                        tag: t("生命科学", "Life Sciences"),
                        title: 'UBio-MolFM: A Universal Molecular Foundation Model for Bio-Systems',
                        date: '2026-02-13',
                        href: 'https://arxiv.org/abs/2602.17709',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'Large-Scale Terminal Agentic Trajectory Generation from Dockerized Environments',
                        date: '2026-02-01',
                        href: 'https://arxiv.org/abs/2602.01244',
                    },
                    {
                        tag: t("生命科学", "Life Sciences"),
                        title: 'Elign: Equivariant Diffusion Model Alignment from Foundational Machine Learning Force Fields',
                        date: '2026-01-29',
                        href: 'https://arxiv.org/abs/2601.21985',
                    },
                    {
                        tag: t("生命科学", "Life Sciences"),
                        title: 'E2Former-V2: On-the-Fly Equivariant Attention with Linear Activation Memory',
                        date: '2026-01-23',
                        href: 'https://arxiv.org/abs/2601.16622',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'Controlled LLM Training on Spectral Sphere',
                        date: '2026-01-13',
                        href: 'https://icml.cc/virtual/2026/poster/66212',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'Polymorphic Universal Transformer',
                        date: '2026-01-06',
                        href: 'https://openreview.net/forum?id=oNM8WcHyRo',
                    },
                    {
                        tag: t("医疗智能", "Medical AI"),
                        title: 'Fleming-R1: Toward Expert-Level Medical Reasoning via Reinforcement Learning',
                        date: '2025-09-18',
                        href: 'https://arxiv.org/abs/2509.15279',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'One-shot Entropy Minimization',
                        date: '2025-05-26',
                        href: 'https://icml.cc/virtual/2026/poster/66725',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'Scaling Laws for Code: Every Programming Language Matters',
                        href: 'https://openreview.net/forum?id=kCmWk1rSjI',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'LoopCoder: Scaling Code Intelligence via Looped Language Models',
                        href: 'https://openreview.net/forum?id=kCmWk1rSjI',
                    },
                    {
                        tag: t("大模型", "Large Models"),
                        title: 'Context as a Tool: Context Management for Long-Horizon SWE-Agents',
                        href: 'https://openreview.net/forum?id=B0nJsiBsbk',
                    },
                ],
            },
        ],
    },
    {
        id: "about",
        index: 3,
        name: t("关于我们", "About Us"),
        children: [
            {
                id: "mission",
                name: t("使命与愿景", "About Us"),
                type: "anchor",
                anchorId: "mission",
                data: {
                    desc: t(
                        '至知创新研究院以\u201c纯粹探索，抵达AI价值的未来\u201d为核心理念，致力于破解尖端研究与真实场景应用之间的转化鸿沟。作为创新型研究组织，研究院集探索者、实战派、连接器三重角色于一身：聚焦下一代AI基础架构，推动自主可控的全栈自研能力；深耕智慧医疗、生物技术、能源电力等高壁垒产业场景，打造端到端智能解决方案；依托全球资源网络，打通从理论到实践的转化链路。这里汇聚顶尖人才，持续培养复合型AI人才。我们以智能计算重写科学规则，以系统方案重塑产业路径，开启AI最具价值的未来。',
                        'IQuest Research for Frontier Innovation is a new, industry-driven research organization at the cutting edge of artificial intelligence. Our core mandate is to bridge the persistent gap between breakthrough research and scalable industry deployment, anchoring our work to frontline industry bottlenecks and offering top research talent an unconstrained space for exploration. Rooted in proprietary foundational algorithms and next-generation AI architecture, we focus on three core pillars: frontier tech breakthroughs, high-complexity real-world deployment, and global academia-industry collaboration, with deep specialisation in AI for Scientific Computing and transformative frontier technologies.'
                    ),
                    partners: [
                        t('北京大学国际数学研究中心', 'Center for Machine Learning Research Peking University'),
                        t('中国科学院', 'Chinese Academy of Sciences'),
                        'OpenDataLab',
                        'Hugging Face',
                        'arXiv',
                        t('中国数学会', 'Chinese Mathematical Society'),
                    ],
                },
            },
            {
                id: "team",
                name: t("核心团队", "Core Team"),
                type: "anchor",
                anchorId: "team",
                data: {
                    members: [
                        {
                            name: "张大大博士",
                            role: "创始人、董事会主席、CEO 兼 CTO",
                            bio: "创办人、CEO 兼 CTO。长期专注 AI 基础架构与多模态推理的工程化落地，致力于将前沿研究转化为可规模化的产业能力。介绍内容正在完善中。",
                        },
                        {
                            name: "李明博士",
                            role: "联合创始人、CTO",
                            bio: "介绍内容正在完善中。",
                        },
                        {
                            name: "王芳博士",
                            role: "联合创始人、首席科学家",
                            bio: "介绍内容正在完善中。",
                        },
                        {
                            name: "陈强",
                            role: "首席运营官",
                            bio: "介绍内容正在完善中。",
                        },
                        {
                            name: "张磊",
                            role: "首席产品官",
                            bio: "介绍内容正在完善中。",
                        },
                        {
                            name: "刘洋博士",
                            role: "研究总监",
                            bio: "介绍内容正在完善中。",
                        },
                    ],
                    join: {
                        email: "hr@iquestlab.com",
                        address: "北京市海淀区中关村东路1号8号楼B座赛尔大厦25楼",
                        phone: "010-88377365",
                        href: joinUsUrl,
                    },
                },
            },
            {
                id: "join",
                name: t("加入我们", "Join Us"),
                type: "page",
                href: joinUsUrl,
                target: "_blank",
            },
        ],
    },
];

export default PAGES_CONFIG;
